<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="params-row request-and-check-all">
    <SwitchSlide :is-active="!store.bypassQueryNews" @toggle="toggleUseRequest"
      >Utiliser la requête</SwitchSlide
    >
    <CheckBox
      :checked="isAllSelected"
      @update:checked="
        () => (isAllSelected ? unselectAllFilters() : selectAllFilters())
      "
    >
      Toutes les activités
    </CheckBox>
  </div>
  <div class="params-row">
    <div class="page-settings filters">
      <FilterCheckBox
        v-for="index in indexes"
        :key="index.filter"
        :label="index.label"
        :color="index.color"
        :item-count="store.newsCounts?.[index.count]"
        :is-checked="lobbiesNewsFilters.includes(index.filter)"
        @check="addFilter(index.filter)"
        @uncheck="removeFilter(index.filter)"
      />
    </div>

    <div class="page-settings">
      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Actualités par page :"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import SwitchSlide from "@follaw-fr/components/reusable/atoms/SwitchSlide.vue";
import CheckBox from "@follaw-fr/components/reusable/atoms/CheckBox.vue";
import FilterCheckBox from "@follaw-fr/components/reusable/atoms/FilterCheckBox.vue";
import { NEWS_FILTERS } from "@follaw-fr/stores/lobbies";
import { useLobbiesStore } from "@follaw-fr/stores/lobbies";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";

const props = defineProps({
  isZoomed: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const store = useLobbiesStore();

const { selectedLobbiesNewsParams, lobbiesNewsFilters } = storeToRefs(store);

const readNews = async () => {
  selectedLobbiesNewsParams.value.from = 0;
  if (props.isZoomed) {
    await store.readOneLobbyNews(route.params._id);
  } else {
    await store.readFollawedNews();
  }
};

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters: selectedLobbiesNewsParams,
    filterKey: "size",
    onChange: () => {
      readNews();
    },
  });

const indexes = [
  {
    label: "Publications",
    color: "var(--clr-network)",
    count: "publicationsCount",
    filter: NEWS_FILTERS.PUBLICATIONS,
  },
  {
    label: "Articles",
    color: "var(--clr-service-article)",
    count: "articlesCount",
    filter: NEWS_FILTERS.ARTICLES,
  },
  {
    label: "Questions",
    color: "var(--clr-service-question)",
    count: "questionsCount",
    filter: NEWS_FILTERS.QUESTIONS,
  },
  {
    label: "Événements",
    color: "var(--clr-p5)",
    count: "eventsCount",
    filter: NEWS_FILTERS.EVENTS,
  },
  {
    label: "Comptes-rendus",
    color: "var(--clr-service-report)",
    count: "reportsCount",
    filter: NEWS_FILTERS.REPORTS,
  },
];

const addFilter = (filter) => {
  lobbiesNewsFilters.value.push(filter);
  readNews();
};

const removeFilter = (filter) => {
  lobbiesNewsFilters.value = lobbiesNewsFilters.value.filter(
    (f) => f !== filter
  );
  readNews();
};

const selectAllFilters = () => {
  lobbiesNewsFilters.value = indexes.map(({ filter }) => filter);
  readNews();
};

const unselectAllFilters = () => {
  lobbiesNewsFilters.value = [];
  readNews();
};

const isAllSelected = computed(
  () => lobbiesNewsFilters.value.length === Object.keys(NEWS_FILTERS)?.length
);

const toggleUseRequest = () => {
  store.bypassQueryNews = !store.bypassQueryNews;
  readNews();
};

const showScrollTop = computed(() => selectedLobbiesNewsParams.value.size > 0);

readNews();
</script>

<style lang="scss" scoped>
.news-params {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.request-and-check-all {
  justify-content: flex-start;
  gap: 15px;
}
.filters {
  gap: 10px;
}
</style>
